import { Outlet } from "react-router-dom";
import CreateChannelContextLayout from "./CreateChannelContextLayout";

const ModalLayout = () => {
  return (
    <div className="container-modal">
      <div className="relative container-modal-content">
        <div>
          <div className="left-0 flex flex-col w-full h-[calc(100vh-144px)] overflow-y-auto top-[84px] ">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalLayout;
